import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';

export default function getFilePaths(files) {
  const paths = [];

  if (!isEmpty(files)) {
    forEach(files, ({ path, enabled }) => {
      if (!isString(path)) {
        console.warn('File path must be a string');
        return;
      }

      if (enabled !== 'undefined' && enabled === false) {
        return;
      }

      paths.push(path);
    });
  }

  return paths;
}
